import React from "react";
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaEnvelope, FaMapMarkerAlt, FaInstagram } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white py-10">
      <div className="container mx-auto px-6">
        {/* Üst Kısım: İletişim Bilgileri */}
        <div className="flex flex-col lg:flex-row justify-between items-center lg:items-start lg:space-x-8">
          {/* Şirket Bilgileri */}
          <div className="mb-8 lg:mb-0 text-center lg:text-left">
            <h4 className="text-xl font-bold mb-4">Softrein</h4>
            <p className="text-sm text-gray-400">
              Üretim teknolojilerinde lider, yenilikçi çözümler sunan bir teknoloji firması.
            </p>
          </div>

          {/* İletişim Bilgileri */}
          <div className="mb-8 lg:mb-0 text-center lg:text-left">
            <h4 className="text-xl font-bold mb-4">İletişim</h4>
            <p className="text-sm flex items-center justify-center lg:justify-start mb-2">
              {/* <FaPhoneAlt className="mr-2" /> +90 (543) 396 14 20 */}
            </p>
            <p className="text-sm flex items-center justify-center lg:justify-start mb-2">
              <FaEnvelope className="mr-2" /> info@softrein.com
            </p>
            <p className="text-sm flex items-center justify-center lg:justify-start">
              <FaMapMarkerAlt className="mr-2" /> İstanbul, Türkiye
            </p>
          </div>

          {/* Sosyal Medya */}
          <div className="text-center lg:text-left">
            <h4 className="text-xl font-bold mb-4">Bizi Takip Edin</h4>
            <div className="flex justify-center lg:justify-start space-x-4">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400">
                <FaFacebookF />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400">
                <FaTwitter />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400">
                <FaLinkedinIn />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400">
                <FaInstagram />
              </a>
            </div>
          </div>
        </div>

        {/* Alt Kısım: Telif Hakkı */}
        <div className="mt-8 text-center text-gray-500 text-sm">
          © 2024 Softrein. Tüm Hakları Saklıdır.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
